module.exports = __webpack_public_path__ + "static/media/Icons- medicine-symbol.c8a54dd4.svg";